// Logger.js

import { useFetch } from "use-http";
import { getDBURL, generateSyncId, correctTimeZone } from "../Utils/Utils";

export const useErrorLogger = () => {
    const { post } = useFetch(getDBURL());

    const DBlogError = async (errorDetails) => {
        try {
            const { error, parameters, userName, moduleName, functionName, description } = errorDetails;
            const response = await post('/addLog', {
                Id: generateSyncId(),
                CreateDate: correctTimeZone(new Date()),
                UserName: userName,
                Module: moduleName,
                FunctionName: functionName,
                Parameters: JSON.stringify(parameters),
                ErrorMessage: error?.message,
                ErrorStack: error?.stack,
                Description: description || (functionName ? `Error occurred in  ${functionName} function` : '')
            });
            if (!response.success) {
                throw new Error('DB logging failed, falling back to file logging');
            }
        } catch (logError) {
            // If the database insertion fails, the code will fallback to logging the error details 
            // into a error.log file located in the same directory as your server script.
            // see api.js '/addlog' route
            console.error('Error logging the error: ', logError.message);
        }
    };

    return { DBlogError };
};
